export type SharedMediaCategory =
  | 'products'
  | 'social_media'
  | 'business_partner'
  | 'marketing'
  | 'training'
  | 'logos'
  | 'other';

export const SHARED_MEDIA_CATEGORY_LABELS: Record<SharedMediaCategory, string> = {
  products: 'Produkte',
  social_media: 'Social Media',
  business_partner: 'Business/Partner',
  marketing: 'Marketing',
  training: 'Schulung',
  logos: 'Logos',
  other: 'Sonstiges',
};

export const SHARED_MEDIA_CATEGORIES: SharedMediaCategory[] = [
  'products',
  'social_media',
  'business_partner',
  'marketing',
  'training',
  'logos',
  'other',
];

export interface SharedMedia {
  id: string;
  filename: string;
  storage_path: string;
  url: string;
  mime_type: string;
  size: number;
  width?: number;
  height?: number;
  alt_text?: string;
  category: SharedMediaCategory;
  product_id?: string;
  product?: { id: string; name: string; slug: string };
  is_active: boolean;
  created_by: string;
  created_at: string;
  updated_at: string;
}

export interface CreateSharedMediaInput {
  file: File;
  category: SharedMediaCategory;
  product_id?: string;
  alt_text?: string;
}

export interface UpdateSharedMediaInput {
  category?: SharedMediaCategory;
  product_id?: string | null;
  alt_text?: string;
  is_active?: boolean;
}

export interface SharedMediaFilters {
  category?: SharedMediaCategory;
  product_id?: string;
  is_active?: boolean;
  search?: string;
}
